import { Component } from '@angular/core';

@Component({
  selector: 'app-savvy-pet-redirect',
  templateUrl: './savvy-pet-redirect.component.html',
  styleUrls: ['./savvy-pet-redirect.component.scss']
})
export class SavvyPetRedirectComponent {
  readonly savvyPetUrl = 'https://app.savvy.pet';
}
